import Vue from 'vue'
const state = Vue.observable({ type: '' })
export const setDark = () => (state.type = 'dark')
export const setLight = () => (state.type = 'light')
export const setGolden = () => (state.type = 'golden')
export default state
